import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChBadgeComponent } from './ch-badge.component';


export class ChBadgeModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  declarations: [ChBadgeComponent],
  exports: [ChBadgeComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
